import styled, { css } from "styled-components";
import getResponsiveBackgroundImageStyles from "../../../helpers/getResponsiveBackgroundImageStyles";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import { getCustomColor } from "../../../utils/getCustomColor";
import space from "../../../utils/space";
import Link from "../../quarks/Link";
import Picture from "../../quarks/Picture";
import ContainerOrg from "../ContainerOrg";
export var BackgroundWrapper = styled.div.withConfig({
  componentId: "sc-19qt2r1-0"
})(function (_ref) {
  var $backgroundColor = _ref.$backgroundColor,
    $backgroundImage = _ref.$backgroundImage,
    $customColor = _ref.$customColor,
    theme = _ref.theme;
  return css(["position:relative;", " ", "{margin:", ";padding:", " 0 ", ";border-radius:", ";", "}", "{width:calc(100% - ", ");}"], $backgroundColor && css(["background-color:", ";"], $customColor ? getCustomColor($customColor.background) : getColor(theme, $backgroundColor)), breakpoint("medium"), space(2), space(6), space(28), getBorderRadius(theme, "large"), $backgroundImage && css(["background-repeat:no-repeat;", ""], getResponsiveBackgroundImageStyles($backgroundImage)), breakpoint("large"), space(4));
});
export var Content = styled.div.withConfig({
  componentId: "sc-19qt2r1-1"
})(["max-width:100%;text-align:left;a,button{position:relative;z-index:1;}", "{padding:", " ", ";}", "{max-width:", ";}", "{max-width:", ";}"], breakpoint("small", "medium"), space(3), space(2), breakpoint("medium", "large"), space(56), breakpoint("large"), space(92));
export var StyledImage = styled(Picture).withConfig({
  componentId: "sc-19qt2r1-2"
})(["width:100%;", "{display:none;}"], breakpoint("medium"));
export var StyledContainerOrg = styled(ContainerOrg).withConfig({
  componentId: "sc-19qt2r1-3"
})(["", "{margin:0;padding:0;}"], breakpoint("small", "medium"));
export var ItemsWrapper = styled.div.withConfig({
  componentId: "sc-19qt2r1-4"
})(["position:relative;z-index:1;margin:", ";margin-top:", ";", "{margin-top:", ";}", "{margin-top:", ";margin-bottom:", ";}"], space(2), space(-4), breakpoint("medium"), space(-6), breakpoint("large"), space(-20), space(2));
export var StyledLink = styled(Link).withConfig({
  componentId: "sc-19qt2r1-5"
})(["", "{&::after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;}}"], breakpoint("medium"));
export var BanerWrapper = styled.div.withConfig({
  componentId: "sc-19qt2r1-6"
})(["", "{display:flex;flex-direction:column;align-items:center;}"], breakpoint("large"));